import React from "react";
import "../styles/blog4.css";

import { useState } from "react";
import { Link } from "react-router-dom";

const Blog4 = () => {
  const [hover, setHover] = useState(false);

  return (
    <main
      className="main-section"
      style={{ maxWidth: 1200, margin: "120px auto 40px auto", padding: 30 }}
    >
      <Link
        to="/blogs"
        style={{
          background: hover ? "#f96e2a" : "#fff",
          border: "1.5px solid #f96e2a",
          borderRadius: 20,
          padding: "7px 22px",
          color: hover ? "#fff" : "#f96e2a",
          fontWeight: 500,
          marginBottom: 28,
          cursor: "pointer",
          boxShadow: "0 2px 14px #f7c69c15",
          textDecoration: "none",
          display: "inline-block",
          transition: "all 0.18s",
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        ← Back to Blogs
      </Link>
      <section className="blog-article">
        <div className="blog-article-header">
        <img
            className="blog-author-photo"
            src={require("../assets/blogs/geetanjali-singh.webp")}
            alt="Geetanjali Singh, Market Research"
          />
          <div className="blog-author-info">
            <span className="blog-author-name">Geetanjali Singh</span>
            <span className="blog-author-role">Market Research, Serenityy</span>
          </div>
        </div>
        <h2 className="blog-article-title">
          Dubai Real Estate 2025: A Market on the Rise
        </h2>
        <span style={{ fontSize: "0.95rem", opacity: 0.7 }}>
          Posted on 4 July 2025
        </span>
        <p>
          The real estate market in Dubai is not just expanding but thriving.
          The city saw a record $89 billion in real estate transactions in the
          first half of 2025 alone, thanks to strong demand, growing investor
          confidence, and an unmatched lifestyle offering. Irrespective matter
          whether you are a professional in the field, an investor, or a
          homeowner, all indications suggest that Dubai is experiencing rapid
          growth.
        </p>

        <h3>A City Growing by the Day</h3>
        <p>
          Dubai is experiencing one of the most dynamic growth phases in its
          recent history. With about 90,000 newcomers in the first three months,
          the city's population has grown to 3.92 million as of March 2025, or
          about 1,000 individuals every day, making Dubai their new home.
          <br />
          <br />
          This migration highlights Dubai's attraction on a global scale as a
          destination for professionals, business owners, and wealthy people
          looking for stability, opportunity, and a high standard of living.
        </p>

        <h3>A Record-Breaking Quarter in Q2 2025</h3>
        <p>Q2 2025 saw the best quarterly performance ever, with:</p>
        <ul>
          <li>
            53,118 transactions totalling AED 184 billion, representing a 48%
            year-over-year rise
          </li>
          <li>Sales value has increased by 25% since the Q4 2024 peak.</li>
        </ul>

        <p>
          <b>Property Type Performance:</b>
        </p>
        <table
          style={{
            width: "100%",
            margin: "16px 0",
            borderCollapse: "collapse",
            fontSize: "0.97em",
          }}
        >
          <thead>
            <tr>
              <th align="left">Property Type</th>
              <th align="left">Value (AED)</th>
              <th align="left">Growth vs. 2024</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Apartments</td>
              <td>81.6B</td>
              <td>+18.7%</td>
            </tr>
            <tr>
              <td>Villas</td>
              <td>66.5B</td>
              <td>+38.3%</td>
            </tr>
            <tr>
              <td>Commercial</td>
              <td>3.6B</td>
              <td>+12.5%</td>
            </tr>
            <tr>
              <td>Plots</td>
              <td>32.2B</td>
              <td>+49%</td>
            </tr>
          </tbody>
        </table>

        <h3>Since 2020, Luxury Sales Have Increased By 10x</h3>
        <p>
          Dubai’s luxury segment continues to lead the charge. Property values
          in Palm Jumeirah and Emirates Hills have increased by up to 20%, with
          daily real estate transactions reaching AED 2 billion, indicating
          excellent liquidity and sustained worldwide demand.
        </p>

        <h3>Why Investors Adore Dubai</h3>
        <ul>
          <li>Capital Gains & Tax-Free Income</li>
          <li>Strong infrastructure and security</li>
          <li>A key point that links the East and the West</li>
          <li>A forward-thinking city that never stops constructing</li>
        </ul>

        <h3>Outlook for 2025: Still Rising</h3>
        <p>
          The message is evident: the real estate market in Dubai is still
          booming. With record sales, rising prices, and global attention, the
          outlook for the rest of 2025 is optimistic and full of promise.
          <br />
          <br />
          Dubai continues to be the best option if you want to invest in a city
          where value and vision coexist.
        </p>
      </section>
    </main>
  );
};

export default Blog4;
